export default __webpack_public_path__ + "static/media/portfolio-3.e1d203d2.jpg";